import { getRegionDomain, useRegion } from '@/entities/regions'

import { clearRegionCookies, clearSearchCookies } from '@/shared/lib/utils/cookies'
import { Title } from '@/shared/ui/Typography'

import styles from './RegionModalContent.module.scss'

export const RegionModalContent = (): JSX.Element => {
	const { allRegions, currentRegion } = useRegion()
	const isActiveRegion = (regionName: string) => currentRegion.REGION_NAME === regionName

	const handleRegionClick = (e: React.MouseEvent<HTMLAnchorElement>, region: (typeof allRegions)[0]) => {
		e.preventDefault()

		// Очищаем старые куки поиска и региона
		clearSearchCookies()
		clearRegionCookies()

		// Устанавливаем новые куки региона
		const futureDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString()
		document.cookie = `CITY_CODE=${region.REGION_CODE}; path=/; domain=.iport.ru; expires=${futureDate}; SameSite=Lax`
		document.cookie = `CITY_NAME=${encodeURIComponent(
			region.REGION_NAME
		)}; path=/; domain=.iport.ru; expires=${futureDate}; SameSite=Lax`

		// Используем replace для редиректа без записи в историю
		window.location.replace(getRegionDomain(region.REGION_CODE))
	}

	return (
		<div className={styles.regionNav}>
			<Title level="2">Выберите город</Title>
			<ul className={styles.list}>
				{allRegions.map(item => (
					<li key={item.REGION_CODE}>
						<a
							className={styles.link}
							href={getRegionDomain(item.REGION_CODE)}
							onClick={e => handleRegionClick(e, item)}
							aria-current={isActiveRegion(item.REGION_NAME) ? `page` : undefined}>
							{item.REGION_NAME}
						</a>
					</li>
				))}
			</ul>
		</div>
	)
}
